import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.443 8L11 4 7.443 0l-.655.736 2.44 2.744H1v1.04h8.229l-2.44 2.744z" /></svg>);